export default "__VITE_ASSET__c03ca539__"